import axios from 'axios'

export const http = axios.create({
    baseURL: '/api',
    timeout: 15000,
    withCredentials: true
})

export default http